import React, { useState } from 'react';

import { PasswordHint } from '../../components/PasswordHint';
import { translations } from '../../locale/translations';
import { SignUpProps } from '../Credentials';
import { Button, ErrorMessage, FormControl, Input, Title } from '../../styles/shared.styles';

export const ResetPassword = ({ lang, userId, changeExpiredPassword }: SignUpProps) => {
    const [currentError, setCurrentError] = useState<string | null>(null);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [showHint, setShowHint] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const locale = translations[lang];
    const p = newPassword || '';
    const hint: Array<[boolean, string]> = [
        [p.length >= 8, locale.passHintLen],
        [p.toLowerCase() !== p && p.toUpperCase() !== p, locale.passHintCase],
        [/[^\w\s]/.test(p), locale.passHintChar],
        [/\d/.test(p), locale.passHintNum]
    ];

    const errorNewOldPassword = oldPassword === newPassword && oldPassword.length > 0;
    const errorMatchPasswords = newPassword !== repeatPassword && repeatPassword.length > 0 && !errorNewOldPassword;
    const passwordValid = !hint.some(([valid]) => !valid);
    const isValid = !errorMatchPasswords && !errorNewOldPassword && passwordValid;

    async function changePassword() {
        if (!isValid) {
            setShowErrors(true);

            return;
        }

        try {
            await changeExpiredPassword({
                userId: userId,
                oldPassword,
                newPassword
            });
        } catch (error) {
            setCurrentError((error as any).message);
        }
    }

    return (
        <>
            <Title>{locale.passwordExpired}</Title>

            <FormControl>
                <label>{locale.oldPassword}</label>
                <Input
                    required
                    type="password"
                    value={oldPassword}
                    onChange={(e) => {
                        setOldPassword(e.target.value);
                        setCurrentError(null);
                    }}
                />
            </FormControl>
            <FormControl>
                <label>{locale.newPassword}</label>
                <Input
                    required
                    type="password"
                    value={newPassword}
                    onBlur={() => setShowHint(false)}
                    onChange={(e) => {
                        setNewPassword(e.target.value);
                        setCurrentError(null);
                    }}
                    onFocus={() => setShowHint(true)}
                />
                {errorNewOldPassword && <ErrorMessage>{locale.newOldPassword}</ErrorMessage>}

                {showErrors && !passwordValid && <ErrorMessage>{locale.wrongPassword}</ErrorMessage>}

                {showHint && <PasswordHint hints={hint} lang={lang} />}
            </FormControl>
            <FormControl>
                <label>{locale.repeatPassword}</label>
                <Input
                    required
                    type="password"
                    value={repeatPassword}
                    onChange={(e) => {
                        setRepeatPassword(e.target.value);
                        setCurrentError(null);
                    }}
                />
                {errorMatchPasswords && <ErrorMessage>{locale.matchPasswords}</ErrorMessage>}
            </FormControl>

            {currentError ? <div className="form-error-message mb-24 center">{currentError}</div> : null}

            <Button data-testid="save-new-password" onClick={changePassword}>
                {locale.save}
            </Button>
        </>
    );
};
